/**
 * 发送邮箱验证码
 */
import styles from "./index.module.scss";

import { Link } from "react-router-dom";

import { Button, Form, Input, Modal } from "antd";

import Logo from "@/assets/image/send/logo.png";
import Banner from "@/assets/image/send/banner.png";
import Check from '@/assets/image/send/check.png';
import { submitSubscription } from '../../api/home';
import {useState} from "react";

const SendCord = () => {
  const [form] = Form.useForm();

  const [show, setShow] = useState(false);

 const onFinish = async (values) => {
  console.log('Success:', values);
   submitSubscription(values).then((res) => {
    setShow(true)
  }).catch((e) => {
    setShow(true)
  })
 };

 const onCancel = () => {
  setShow(false);
 }

  return (
    <div className={`${styles.container} flex`}>
      <header className={`${styles.header}`}>
        <Link to={"/"}>
          <img className={`${styles.logo}`} src={Logo} alt="" />
        </Link>
      </header>

      <main className={`${styles.main} flex`}>
        <div className={`${styles.ruleForm} flex`}>
          <h1>Welcome to VIshwa. The First ZK Infrastructure for PayFi!</h1>
          <p>* denotes required fields</p>

          <Form form={form} layout="vertical" autoComplete="off" onFinish={onFinish}>
            <Form.Item
              name="name"
              label={<label>What's your name or the alias you prefer? *</label>}
              rules={[{ required: true, message: "Please enter your name" }]}
              className={`${styles.mb40}`}
            >
              <Input
                placeholder="Type your answer here..."
                className={styles.input}
              />
            </Form.Item>

            <Form.Item
              name="email"
              label={<label>What's your e-mail address? *</label>}
              rules={[
                { required: true, message: "Please enter your email" },
                {
                  type: "email",
                  message: "Please enter a valid email adddess",
                },
              ]}
              className={`${styles.mb40}`}
            >
              <Input
                placeholder="Type your answer here..."
                className={styles.input}
              />
            </Form.Item>
           <Form.Item
            name="telegram"
            label={<label>What's your telegram handle?</label>}
            className={`${styles.mb40}`}
           >
            <Input
             placeholder="Type your answer here..."
             className={styles.input}
            />
           </Form.Item>
            <Form.Item>
              <Button
                className={`${styles.submit}`}
                type="primary"
                htmlType="submit"
              >
                OK
              </Button>
            </Form.Item>
          </Form>
        </div>

        <img src={Banner} className={`${styles.banner}`} alt="" />
      </main>

      <p className={`mobile ${styles.tips}`}>
        *Please note: This form is exclusively for submissions related to
        developer activities. Any non-developer related submissions will not be
        processed.
      </p>

     <Modal open={show} maskClosable={false} footer={null} className={`${styles.modalConfirm}`} keyboard={false} onCancel={onCancel}>
      <div className={`${styles.modal} flex`}>
       <img src={Check} alt=""/>

       <h2>Thank you for your interest in Vishwa!</h2>

       <p>We will review your submission and contact you as soon as possible.</p>
      </div>
     </Modal>
    </div>
  );
};

export default SendCord;
